import { createSlice } from '@reduxjs/toolkit';

const subFunctionAccessSlice = createSlice({
  name: 'subFunctionAccess',
  initialState: {
    access: {},
  },
  reducers: {
    setSubFunctionAccess: (state, action) => {
      state.access = action.payload;
    },
    updateSubFunctionAccess: (state, action) => {
      state.access = { ...state.access, ...action.payload };
    },
    resetSubFunctionAccess: (state) => {
      state.access = {};
    },
  },
});

export const { setSubFunctionAccess, updateSubFunctionAccess, resetSubFunctionAccess } = subFunctionAccessSlice.actions;
export default subFunctionAccessSlice.reducer;
